import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.1/js/sparta-store-utility";
import spartaValidationFramework from "utilities/global/sparta-validation-framework/7.1.6/js/sparta-validation-framework";









const utilityNamespace = 'AhU2FCommonsUtility';






 const EVENTS = {};
 let deliveryType = "";

 const GLOBALS = {
      "isSm":false,
      "failedAttempt":1,
      "isOLBFLOW":false
 }

export default class AhU2FCommonsUtility {
  constructor(options) {
        this.$ = options.$;
        this._ = options._;
        this.cawCommons = options.cawCommons;
        this.cawEventsMaster = options.cawEventsMaster;
        this.constructorParams = options.constructorParams;
        this.parentModule = options.context;
        this.spartaUILayersUtility = options.spartaUILayersUtility;
        this.spartaMessageUtil = options.spartaMessageUtil;
        this.spartaValidationFramework = options.spartaValidationFramework;
        this.jsEncrypt = options.jsEncrypt;
        this.Handlebars = options.hb;
        this.parentModule.ahCawTransportUtility = options.ahCawTransportUtility;
        this.parentModule.clientParams = this.constructorParams.clientParams;
        const basePath = this.cawCommons.getBasePath(this.parentModule.spaParams);
        this.parentModule["apiEndPoints"] = this.cawCommons.getEndPoints(this.constructorParams.apiEndPoints, basePath);
        window.jQuery = this.$;
  }


  _subscribeEvents(){
    const $ = this.$;
    const me = this;

    this.parentModule.Events.sub("AH_U2F_INIT",function(e){
       me._triggerU2f('NON-SM','init');
    },true);


    this.parentModule.Events.sub("AH_U2F_INIT_SECURE",function(e){
      me._triggerU2f('NON-SM','init');
      if(e){
        me.parentModule.Store.addData('widgetConfigData', e);

              }
      me.Globals.isOLBFLOW = true;
   },true);

    this.parentModule.Events.sub("AH_WIDGET_U2F_INIT",function(e){
      if(e){
        me.parentModule.Store.addData('widgetConfigData', e);
      }
      me._triggerU2f('NON-SM','init');
   },true);


    this.parentModule.Events.sub("AH_U2F_INIT_SM",function(e){
      if(e){
        me.parentModule.Store.addData('widgetConfigData', e);
        me.Globals.isSm = true;
        if(_.get(e,'data.widgetType') === 'MODAL'){
          me.Globals.isModal = true;
        }
        if(_.get(e,'data.publishNS')){
          me.Globals.Namespace = _.get(e,'data.publishNS');
        }
        if(_.get(e,'data.origin')){
          me.Globals.origin = _.get(e,'data.origin');
        }
      }
      me._triggerU2f("SM",'init');
   },true);


    this.parentModule.Events.sub("AH_U2F_CLEANUP",function(e){
      me._cleanU2F();
    },true);
    return this;
  }


  _cleanU2F(){
    const $ = this.$;
    $('#ah-U2f-container').addClass('hidden');
    $('#verifying-u2f').addClass('hidden');
    $('#verification-failed-u2f').removeClass('hidden');
  }

  _getDefault(e){
    if(e==='options'){
      return {
        "username": "SECOND_FACTOR",
        "authenticatorSelection": {
          "userVerification": "discouraged"
        }
      } 
    }else if(e === 'stepup'){
      return {
          "authenticationLevel":{
              "code":"targetAuthLevel",
              "value":"400"
          },
          "processRules":[{
            "name":"AuthenticationContext",
            "value":"TO_BE_FILLED"
          },
          {
            "name":"U2F_ENABLED",
            "value":"true"
          }],
          "stepUpToken":{
            "stepUpType":"OTP"
          },
          "forcedOTP":true, 
          "restrictToDeliveryMethod":"U2F_FB"
        }
    }
  }


  _prepareModal(){
    const self = this;
    const u2fModule = this.parentModule;
    const $ = this.$;
        this.modalContentID = 'U2FContentID';
        const $modalContentWrapper = $('#ah-U2f-container');

        const options = {
            type: 'modal',
            closeOnEscape: true,
            closeButton: true,
            optionalClasses: `u2f-modal-content`,
            contentId: this.modalContentID,
            width: 'auto',
        };

        $modalContentWrapper.data('options', options);
        self.spartaUILayersUtility.openLayer($modalContentWrapper);
}

  _triggerU2f(type,initiatorType){
    const self = this;
    const u2fModule = this.parentModule;
    const $ = this.$;
    let $jContext = self.getContext();

    if(self.Globals.isModal && initiatorType === 'init'){
      if(!self.Globals.U2FINITDOM){

          self.Globals.U2FINITDOM = $('#ah-U2f-container').clone(true);
      }else{
        if($('#U2FContentIDSpartaUILayer').length === 0){
          $("#"+u2fModule.view.settings.target.getAttribute('id')).html(self.Globals.U2FINITDOM);
        }

      }
    }

    if(initiatorType === 'init'){
      self.Globals.failedAttempt = 1;
      $jContext.find("#try-again-text").removeClass('hidden');
    }

    if(!self.Globals.isModal){
      $('#ah-U2f-container').removeClass('hidden');
      $('#verifying-u2f').removeClass('hidden');
      $('#verification-failed-u2f').addClass('hidden');
    }
    if(self.Globals.isModal){
      $('#u2f-error-img-container').removeClass('hidden');
      $('#u2f-error-img-container').addClass('small-2 columns');
      $('#u2f-error-img-container').attr('style','margin-top:50px');
      $('#u2f-error-content .verify-text-bold').attr('style','margin-left: -30%;font-size: 22px;')
      $('#u2f-error-content').addClass('small-10 columns');
      self.spartaUILayersUtility.closeLayer();
    }
    let OptionsUrl = u2fModule["apiEndPoints"].assertionOptions;
    if(type && type ==="SM"){
      $("#u2f-stepup-text").removeClass('hidden');
      $("#u2f-login-text").addClass('hidden');
      OptionsUrl = u2fModule["apiEndPoints"].assertionSmOptions;
    }
    let requestPayload = this._getDefault('options');



    if(requestPayload && type==="SM"){
      requestPayload.extensions = {};
      const widgetConfig = this.parentModule.Store.getData("widgetConfigData");

      if(widgetConfig && widgetConfig.data && widgetConfig.data.pageID){
        requestPayload.extensions.AuthenticationContext = widgetConfig.data.pageID;
      }
      else{
        requestPayload.extensions.AuthenticationContext = U2FModule.clientParams.pageID;
      }  
    }
    if(requestPayload&&requestPayload.extensions&&requestPayload.extensions.AuthenticationContext){
      if(/^(MONEYXFER|ADDEDITXFER|WIREXFER)$/.test(requestPayload.extensions.AuthenticationContext)){
        requestPayload.extensions.StepUpToken = "true";
      }
    }
    const ajaxOptions = {
      method: 'POST',
      data: JSON.stringify(requestPayload),
      url: OptionsUrl,
      crossDomain: true,
      cache: false,
      timeout: 60000,
      processData: false,
      xhrFields: {
          withCredentials: true,
      },
      headers: {
          'content-type': 'application/json',
          clientAIT: '41339',
          accept: 'application/json',
          'cache-control': 'no-cache',
      },
      dataType: 'json',
  };
  const initiateCall = u2fModule.ahCawTransportUtility;
  initiateCall._serviceCall(ajaxOptions, (response) => {
    let publicKey = self.preformatGetAssertReq(response.responseData);
    navigator.credentials.get({ publicKey })
    .then((CredentialInfo) => {
      self._triggerAssertionResult(CredentialInfo,type); 
    })
    .catch((error) => {
      self._handleErrorAttempts();
      $('#ah-U2f-container').removeClass('hidden');
      $('#verifying-u2f').addClass('hidden');
      $('#verification-failed-u2f').removeClass('hidden');
    });
  },function(error){
    self._handleErrorAttempts();
    $('#ah-U2f-container').removeClass('hidden');
    $('#verifying-u2f').addClass('hidden');
    $('#verification-failed-u2f').removeClass('hidden');
  });  
  }

  _handleErrorAttempts(){
    const self = this;
    const $ = this.$;
    if(self.Globals.isModal){
      self._prepareModal();
    }
    if(self.Globals.failedAttempt === 5){
      $('#try-again-text').addClass('hidden');
    }
  }


  _triggerAssertionResult(CredentialInfo,type){
    const self = this;
    const u2fModule = this.parentModule;
    const $ = this.$;


      let ResultUrl = u2fModule["apiEndPoints"].assertionResult;
    if(type && type==='SM'){
      ResultUrl = u2fModule["apiEndPoints"].assertionSmResult;
    }
    let requestPayload = self.publicKeyCredentialToJSON(CredentialInfo);



    const ajaxOptions = {
      method: 'POST',
      data: JSON.stringify(requestPayload),
      url: ResultUrl,
      crossDomain: true,
      cache: false,
      timeout: 60000,
      processData: false,
      xhrFields: {
          withCredentials: true,
      },
      headers: {
          'content-type': 'application/json',
          clientAIT: '41339',
          accept: 'application/json',
          'cache-control': 'no-cache',
      },
      dataType: 'json',
  };
  const initiateCall = u2fModule.ahCawTransportUtility;
  initiateCall._serviceCall(ajaxOptions, (response) => {
      let U2FSuccess = self.cawEventsMaster.EVENTS.U2F_SUCCESS;
      let U2FSuccessStepup = U2FSuccess+'_STEPUP';
      let U2FSuccessResponse = U2FSuccess+'_RESPONSE';
      self.publishEvent(U2FSuccess,response.responseData);

      self.publishEvent(U2FSuccessStepup,response.responseData.returnToken);
      self.publishEvent(U2FSuccessResponse,response.responseData);


      if(self.Globals.isModal){
        self.spartaUILayersUtility.closeLayer();

      }
    },function(error){
      self.publishEvent('AH_UNIVERSAL_STEPUP_FATAL_ERROR',error);
    });
  }

  publishEvent(eventName, data) {
      const that = this;


      if(that.Globals.Namespace){
        this.parentModule.Events.pub(eventName+that.Globals.Namespace, data);
      }else{
        this.parentModule.Events.pub(eventName, data);
      }
  }

  _defineVars()  {
    const self = this;
    const u2fModule = this.parentModule;
    const $ = this.$;
    u2fModule.templates = {};

    u2fModule.$moduleContext = $(u2fModule.view.settings.target);
      const elementsID = {
          'main-container': 'ah-U2f-container',
          'poll-target': 'verifying-u2f'
      };

      const elementsClass = {};


      this.elementsSelectors = {};

      $.each(elementsID, (i, val) => {
          this.elementsSelectors[i] = `#${val}`;
      });
      $.each(elementsClass, (i, val) => {
          this.elementsSelectors[i] = `.${val}`;
      });


    return this;
  } 


  publicKeyCredentialToJSON (pubKeyCred){
    const that = this;
    const u2fModule = this.parentModule;
    const $ = this.$;

      if(pubKeyCred instanceof Array) {
          let arr = [];
          for(let i of pubKeyCred)
              arr.push(this.publicKeyCredentialToJSON(i));
          return arr
      }
      if(pubKeyCred instanceof ArrayBuffer) {
          return that.encode(pubKeyCred)
      }
      if(pubKeyCred instanceof Object) {
          let obj = {};
          for (let key in pubKeyCred) {
              obj[key] = this.publicKeyCredentialToJSON(pubKeyCred[key])
          }
          return obj
      }
      return pubKeyCred
  }

  encode (arraybuffer) {

    let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';

              let lookup = new Uint8Array(256);
              for (let i = 0; i < chars.length; i++) {
                  lookup[chars.charCodeAt(i)] = i;
              }
    let bytes = new Uint8Array(arraybuffer),
    i, len = bytes.length, base64url = '';
    for (i = 0; i < len; i+=3) {
        base64url += chars[bytes[i] >> 2];
        base64url += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
        base64url += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
        base64url += chars[bytes[i + 2] & 63];
    }
    if ((len % 3) === 2) {
        base64url = base64url.substring(0, base64url.length - 1);
    } else if (len % 3 === 1) {
        base64url = base64url.substring(0, base64url.length - 2);
    }
    return base64url;
  };

preformatGetAssertReq(getAssert) {
    const self = this;
    const u2fModule = this.parentModule;
    const $ = this.$;

    getAssert.challenge = self.decode(getAssert.challenge);

        for(let allowCred of getAssert.allowCredentials) {
        allowCred.id = self.decode(allowCred.id);
    }
    return getAssert
}


decode(base64string) {
    const self = this;
    const u2fModule = this.parentModule;
    const $ = this.$;
  let chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';

  let lookup = new Uint8Array(256);
  for (let i = 0; i < chars.length; i++) {
      lookup[chars.charCodeAt(i)] = i;
  }
  let bufferLength = base64string.length * 0.75,
  len = base64string.length, i, p = 0,
  encoded1, encoded2, encoded3, encoded4;
  let bytes = new Uint8Array(bufferLength);
  for (i = 0; i < len; i+=4) {
      encoded1 = lookup[base64string.charCodeAt(i)];
      encoded2 = lookup[base64string.charCodeAt(i+1)];
      encoded3 = lookup[base64string.charCodeAt(i+2)];
      encoded4 = lookup[base64string.charCodeAt(i+3)];
      bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
      bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
      bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
  }
  return bytes.buffer
};

    _bindEventHandlers(){
    const self= this;
    const $ = this.$;
    let $jContext = self.getContext();
    $jContext.find("#try-again-text").off("click").on("click", (e) => {
      let type = self.Globals.isSm ? 'SM' : 'NON-SM';
      if(self.Globals.failedAttempt < 5){
        self.Globals.failedAttempt = self.Globals.failedAttempt + 1;
        self._triggerU2f(type,'retry');
      }else if(self.Globals.failedAttempt === 5){
        $jContext.find("#try-again-text").addClass('hidden');
        if(self.Globals.isModal){
          $('#try-again-text').addClass('hidden');
        } 
        self._triggerU2f(type,'retry');
      }
    });

        $jContext.find("#dont-key-text").off("click").on("click", () => {
      self._cleanU2F();
      if(self.Globals.isModal){
        $('#U2FContentIDSpartaUILayer').remove();
      }
      if(!self.Globals.isOLBFLOW && (self.Globals.origin === "CAW" || !self.Globals.isSm)) {
        self._initiateStepup();
      } else {
        self.publishEvent('AH_U2F_FB_INITIATE',self.parentModule.clientParams.pageID);
      }
    });

    return this;
  }

    _initiateStepup(){
    const self = this;
        const U2FModule = this.parentModule;
        const $ = this.$;
        const _ = this._;
    let stepUpUrl = "";
    let requestPayload ="";
    if(!self.Globals.isSm){
      stepUpUrl = U2FModule["apiEndPoints"].stepUpUrl;
    }else{
      stepUpUrl = U2FModule["apiEndPoints"].smStepUpUrl;
    }
    requestPayload = this._getDefault('stepup');

    const widgetConfig = this.parentModule.Store.getData("widgetConfigData");

    if(widgetConfig && widgetConfig.data && widgetConfig.data.pageID){
      requestPayload.processRules[0].value = widgetConfig.data.pageID;
    }else{
      requestPayload.processRules[0].value = U2FModule.clientParams.pageID;
    }  
    const ajaxOptions = {
      method: 'POST',
      data: JSON.stringify(requestPayload),
      url: stepUpUrl,
      crossDomain: true,
      cache: false,
      timeout: 60000,
      processData: false,
      xhrFields: {
          withCredentials: true,
      },
      headers: {
          'content-type': 'application/json',
          clientAIT: '41339',
          accept: 'application/json',
          'cache-control': 'no-cache',
      },
      dataType: 'json',
  };
  const initiateCall = U2FModule.ahCawTransportUtility;
  initiateCall._serviceCall(ajaxOptions, (response) => {
        self._decideStepupToInit(response);
  },function(error){

  });
}

_decideStepupToInit(initAuthJsonDataResponse) {
  const stepupModule = this.parentModule;
  const $ = stepupModule.$;
  this.parentModule._debug(`inside _decideStepupToInit with... \ninitAuthResponse:
          ${initAuthJsonDataResponse.responseData ? JSON.stringify(_.get(initAuthJsonDataResponse, "responseData")) : "null"}
          \neventData: ${JSON.stringify(eventData)}`);
  let eventData = new Object();
  let widgetConfigInfo = this.parentModule.Store.getData("widgetConfigData");
  if(widgetConfigInfo && widgetConfigInfo.data){
    eventData = widgetConfigInfo.data;
  }
  eventData['helper-data']= _.get(initAuthJsonDataResponse, "responseData");

  if (initAuthJsonDataResponse && _.get(initAuthJsonDataResponse, "responseData.stepUpToken")) {
    let stepupType = _.get(initAuthJsonDataResponse, "responseData.stepUpToken.stepUpType");
    if (stepupType === "MTG") {
          this._initiateMTG(eventData);
      } else if (/^(OTP|OTP_VERIFY_CVV|OTP_VERIFY_PIN|DEBIT_CARD|DEBIT_CARD_PIN|CREDIT_CARD)$/.test(stepupType)) {
          this._initiateOTP(eventData);
      } 
      else if (stepupType === 'U2F') {
          this._initiateU2fModule(eventData);
      }
  } else if (initAuthJsonDataResponse && _.get(initAuthJsonDataResponse, "responseData.errorInfo.0.code")) {
      this.parentModule._debug('got error info object');
      this._initiateOTP(eventData);
  }
}

_initiateU2fModule(e){

  this.parentModule.Events.pub(this.EVENTS.U2F_INITIATE, e);
}

_initiateOTP(eventData) {

  if(eventData['helper-data']) {
      eventData.firstStep='SHOW_CONTACTS';
  }

  if(eventData.forcedStepUp) {
      eventData.forcedOtp = eventData.forcedStepUp;
  }

  this.publishEvent('AH_UNIVERSAL_OTP_INITIATE', eventData);
}

_initiateMTG(eventData) {
  this.publishEvent('AH_UNIVERSAL_MTG_INITIATE', eventData);
}

  getContext() {
    const self = this;
    const u2fModule = this.parentModule;
    const $ = this.$;

    return u2fModule.$moduleContext;
}

get Globals(){
  return GLOBALS;
}

  _bindThisContext(){
    return this;
  }

}